var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.permission?.display)?_c(_setup.ActionButton,{attrs:{"text":_vm.permission?.display,"disabled":_setup.disabled,"rounded":true},on:{"action-click":_setup.onClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }